import { store } from '../../../redux';
import { openNotificationPopIn } from '../../../redux/actions';
import { localStorageFuncs } from '../../helpers/';
import { AlertTypeEnum, NotificationData } from '../types';

export const windshieldReminderHandler = (e: MessageEvent) => {
  const notification = JSON.parse(e.data) as NotificationData;
  localStorageFuncs.set('lastSyncTimeStamp', new Date().getTime());
  const title = 'Alerte Pare-brise';
  const subTitle = `Les trains suivants ont un pare-brise sale :`;
  const confirmTxt = 'OK';
  store.dispatch(
    openNotificationPopIn(
      title,
      subTitle,
      notification.data as string[],
      confirmTxt,
      AlertTypeEnum.WindshieldReminder,
    ),
  );
};

export default windshieldReminderHandler;
